module.exports = __webpack_public_path__ + "static/media/5.ae29b463.svg";